module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/HowToFileClaimSection/sign-in-account-273e418c922c5ee56ccb2b1440520f87.png";